<section class="pt-2">
    <div class="container-style">
        <div class="row align-items-center pb-2">
            <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                <h6> {{ isFormView ? 'Registrar detalle de medidores' : 'Detalle de medidores' }} </h6>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
                <div class="d-flex gap-2">
                    <app-custom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledDetail"
                        [width]="'7rem'" (onClick)="openArticleSelectionModal()"></app-custom-button>
                    <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Selección de Artículos'"
                        [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
                        (selectedItems)="handleSelectedItem($event)" hidden>
                    </app-custom-modal>
                </div>
            </div>
        </div>
        <div class="row mx-0" [hidden]="!isFormView">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
                <app-register-meter-detail [meterDetails]="meterDetails" [meterModel]="meterModel"
                    [meterDetailContract]="meterDetail" (isFormView)="getFormView($event)"
                    (updateListDetail)="getDetailsForCapture()">
                </app-register-meter-detail>
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
            <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
                [showCheckbox]="!disabledDetail" [checkBoxAction]="checkboxActions"
                [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getDetailsForCapture()"
                (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
            </app-custom-table>
        </div>
    </div>
</section>